import { N19Service } from '@modules/admin/pages/n19/n19.service';
import { Component } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ConfirmModalComponent } from '@components/confirm-modal/confirm-modal.component';

@Component({
  selector: 'app-n22',
  templateUrl: './n22.component.html',
  styleUrls: ['./n22.component.scss']
})
export class N22Component {

  form = new FormGroup({
    leadRegion: new FormControl(null, [Validators.required]),
    selfRegion: new FormControl(null, [Validators.required]),
    leadProvince: new FormControl(null, [Validators.required]),
    selfProvince: new FormControl(null, [Validators.required]),
  });
  regions = [
    "Miền Bắc",
    "Miền Trung",
    "Miền Nam",
    "Vùng khác"
  ]

  provinces = [
    "HN1",
    "HN2",
    "HN3",
    "HN4",
    "HN5",
    "Bắc Ninh",
    "Hà Nam",
    "Hải Dương",
    "Hải Phòng",
    "Hưng Yên",
    "Nam Định",
    "Ninh Bình",
    "Thái Bình",
    "Vĩnh Phúc",
    "Hòa Bình",
    "Sơn La",
    "Điện Biên",
    "Lai Châu",
    "Lào Cai",
    "Yên Bái",
    "Phú Thọ",
    "Hà Giang",
    "Tuyên Quang",
    "Cao Bằng",
    "Bắc Kạn",
    "Thái Nguyên",
    "Lạng Sơn",
    "Bắc Giang",
    "Quảng Ninh",
    "Thanh Hóa",
    "Nghệ An",
    "Hà Tĩnh",
    "Quảng Bình",
    "Quảng Trị",
    "Thừa Thiên Huế",
    "TP Đà Nẵng",
    "Quảng Nam",
    "Quảng Ngãi",
    "Bình Định",
    "Phú Yên",
    "Khánh Hòa",
    "Ninh Thuận",
    "Bình Thuận",
    "Kon Tum",
    "Gia Lai",
    "Đắk Lắk",
    "Đắk Nông",
    "Lâm Đồng",
    "Long An",
    "Đồng Tháp",
    "Tiền Giang",
    "An Giang",
    "Bến Tre",
    "Vĩnh Long",
    "Trà Vinh",
    "Hậu Giang",
    "Kiên Giang",
    "Sóc Trăng",
    "Bạc Liêu",
    "Cà Mau",
    "TP Cần Thơ",
    "Bình Dương",
    "Bình Phước",
    "Đồng Nai",
    "Tây Ninh",
    "Bà Rịa - Vũng Tàu",
    "SG1",
    "SG2",
    "SG3",
    "SG4",
    "SG5",
    "Khu vực khác"
  ]

  constructor(
    private dialogRef: MatDialogRef<N22Component>,
    private n19Service: N19Service,
    private dialog: MatDialog,
  ) {
    this.dialogRef.disableClose = true;
  }
  onSubmit() {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return
    }
    const dialogRef = this.dialog.open(ConfirmModalComponent, {
      data: {
        title: 'Xác nhận',
        content: `Bạn có muốn xác nhận thông tin này không?`,
      },
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.n19Service.getUpdate(this.form.getRawValue()).subscribe({
          next: result => {
            this.dialogRef.close();
            this.dialog.open(ConfirmModalComponent, {
              data: {
                title: 'Thành công',
                content: `Xác nhận thành công!`,
                type: 'success',
              },
            });
          }
        })
      }
    });
  }
  getErrorMessage(formControl) {
    if (formControl.hasError('required')) {
      return 'Không được bỏ trống';
    }
    if (formControl.hasError('minlength')) {
      return 'Nhập ít nhất 9 ký tự';
    }
    if (formControl.hasError('pattern')) {
      return 'Chỉ được nhập số';
    }
    return '';
  }
  checkValidators(control: AbstractControl) {
    return (control.invalid && control.touched) || (control.invalid && control.dirty)
  }
}
